import { AppThunk } from './store'
import { Actions } from './actions'
import ky from '@rsmus/ky-auth'
import { ClientUser, TeamAssignment } from '../models'
import { buildApiUrl } from '../apiUrl'

let controller = new AbortController()

const getClientUsersError = async (response: Response) => {
  if (response.status === 403 || response.status === 404) {
    return new Error('You are not authorized to view or manage users for this client.')
  }

  if (response.status === 429) {
    return new Error('Too many client user requests were submitted. Please wait a minute and try again.')
  }

  const message = await response.text()
  return new Error(message || response.statusText)
}

export const getById =
  (id: string): AppThunk =>
  async (dispatch) => {
    controller.abort()

    try {
      const { signal } = controller
      dispatch(Actions.getClientUsersBegin())

      const url = buildApiUrl(`clients/${id}/users`)

      const response = await ky.get(url, {
        signal,
        timeout: 30000,
        throwHttpErrors: false,
      })

      if (!response.ok) {
        throw await getClientUsersError(response)
      }

      const results = (await response.json()) as Array<ClientUser>

      dispatch(Actions.getClientUsersEnd(results))
      dispatch(Actions.setClientIdEnd(id))
    } catch (error) {
      dispatch(Actions.getClientUsersError(error))
      dispatch(Actions.setClientIdEnd(''))
    }
  }

export const clearUsers = (): AppThunk => (dispatch) => {
  dispatch(Actions.clearClientUsers())
}
export const SetUserStatus =
  (assignment: TeamAssignment): AppThunk =>
  (dispatch) => {
    const usercilent: ClientUser = {
      email: assignment.email,
      userId: assignment.userId,
      name: assignment.name + '',
      firstName: assignment.firstName,
      lastName: assignment.lastName,
      type: assignment.type,
      role: assignment.eidRole + '',
      roleDescription: assignment.eidRoleDescription + '',
      rsmIsFederated: assignment.rsmIsFederated,
      status: assignment.status + '',
      lastLogin: assignment.lastLogin + '',
    }
    dispatch(Actions.setUserStatus(usercilent))
  }
